import React, { useEffect } from 'react';
import { LandingNav } from '../components/landing/LandingNav';
import { PricingPlans } from '../components/landing/PricingPlans';
import { FaqList } from '../components/landing/FaqList';
import { FinalCta } from '../components/landing/FinalCta';
import { SiteFooter } from '../components/landing/SiteFooter';
import { baht, bookingFee } from '../utils/format';
const example = {
  fee: 12000,
  travel: 800
};
export function Pricing() {
  useEffect(() => window.scrollTo(0, 0), []);
  const subtotal = example.fee + example.travel;
  const fee = bookingFee(subtotal);
  return <div className="min-h-screen w-full bg-bg text-ink" data-id="element-1344" data-mp="3h8hqdg3qq06a">
      <LandingNav data-id="element-1345" data-mp="3hb3xjempydnz" />
      <main data-id="element-1346" data-mp="3c9y3ndhbokcv">
        <section aria-labelledby="pricing-title" className="mx-auto max-w-6xl px-5 pb-20 pt-16 lg:pt-24" data-id="element-1347" data-mp="3cag6wu2ejyua">
          <h1 id="pricing-title" className="max-w-[16ch] text-[44px] font-bold leading-[1.0] tracking-[-0.02em] lg:text-[72px]" data-id="element-1348" data-mp="1fi671pgezx67">
            Simple, fair pricing.
          </h1>
          <p className="mt-5 max-w-[52ch] text-[18px] leading-relaxed text-ink-2" data-id="element-1349" data-mp="1elyblrzbh4tb">
            Joining, swiping, matching and chatting are free for everyone. We earn when a gig is confirmed — and sell a little extra reach if you want it.
          </p>
          <div className="mt-12" data-id="element-1350" data-mp="14pbqr36zqdra">
            <PricingPlans data-id="element-1351" data-mp="14q526hgw9rfr" />
          </div>
        </section>

        <section aria-labelledby="example-title" className="mx-auto grid max-w-6xl gap-10 border-t border-line px-5 py-20 lg:grid-cols-[1fr_1.1fr]" data-id="element-1352" data-mp="19nn3pmsl14dq">
          <div data-id="element-1353" data-mp="22bj3j0dg7ceq">
            <h2 id="example-title" className="text-[32px] font-bold leading-[1.08] tracking-[-0.015em] lg:text-[40px]" data-id="element-1354" data-mp="22c2chrl4eqgm">
              How the booking fee works
            </h2>
            <p className="mt-4 max-w-[44ch] text-[17px] leading-relaxed text-ink-2" data-id="element-1355" data-mp="1slptw4wv97d4">
              A singer quotes ฿12,000 plus ฿800 travel. The organiser accepts. Here’s where the money goes.
            </p>
          </div>
          <dl className="divide-y divide-line rounded-lg bg-surface-2 px-6 text-[17px]" data-id="element-1356" data-mp="2l2ac3zpm2ys2">
            <div className="flex justify-between py-4" data-id="element-1357" data-mp="2uyiw8bwhfg9g">
              <dt className="text-ink-2" data-id="element-1358" data-mp="2ux7qi6jh7yfp">Performance fee</dt>
              <dd className="tabular font-bold" data-id="element-1359" data-mp="2pzz9i9a2e0g1">{baht(example.fee)}</dd>
            </div>
            <div className="flex justify-between py-4" data-id="element-1360" data-mp="2lwjetihk2a5z">
              <dt className="text-ink-2" data-id="element-1361" data-mp="2lzf98wu72gpo">Travel</dt>
              <dd className="tabular font-bold" data-id="element-1362" data-mp="2gx6h22p5biom">{baht(example.travel)}</dd>
            </div>
            <div className="flex justify-between py-4" data-id="element-1363" data-mp="2bzeod6gofsjd">
              <dt className="text-ink-2" data-id="element-1364" data-mp="2c0zln3udlpkx">Encorza booking fee (6%)</dt>
              <dd className="tabular font-bold" data-id="element-1365" data-mp="276vdwidaddis">{baht(fee)}</dd>
            </div>
            <div className="flex justify-between py-4" data-id="element-1366" data-mp="22adabltozl81">
              <dt className="font-bold" data-id="element-1367" data-mp="1y7qg5e9jto7o">Organiser pays</dt>
              <dd className="tabular text-xl font-bold" data-id="element-1368" data-mp="1y9bb34zrz962">{baht(subtotal + fee)}</dd>
            </div>
            <div className="flex justify-between py-4" data-id="element-1369" data-mp="1t842j3pt65yc">
              <dt className="font-bold" data-id="element-1370" data-mp="1o90vxeu6jro9">Singer receives</dt>
              <dd className="tabular text-xl font-bold text-brand-strong" data-id="element-1371" data-mp="1obncg3z1thim">{baht(subtotal)}</dd>
            </div>
          </dl>
        </section>

        <section aria-labelledby="faq-title" className="mx-auto max-w-3xl px-5 pb-24" data-id="element-1372" data-mp="8q370s1vyaz6">
          <h2 id="faq-title" className="mb-8 text-[32px] font-bold tracking-[-0.015em]" data-id="element-1373" data-mp="dpz5ycvq7c7v">
            Questions
          </h2>
          <FaqList data-id="element-1374" data-mp="hq9lag5ereze" />
        </section>
        <FinalCta data-id="element-1375" data-mp="hp6su3sft4hd" />
      </main>
      <SiteFooter data-id="element-1376" data-mp="3h6oc3xrecjx0" />
    </div>;
}